import api from '@/services/api'

const state = {
  loading: false,
  success: false,
  error: false
}

const mutations = {
  setLoading (state, loading) {
    state.loading = loading
  },
  setSuccess (state, success) {
    state.success = success
  },
  setError (state, error) {
    state.error = error
  }
}

const actions = {
  sendEmail ({commit}, payload) {
    commit('setLoading', true)

    return api.contact.sendEmail(payload)
      .then(response => {
        commit('setLoading', false)
        commit('setSuccess', true)

        return response
      })
      .catch(error => {
        commit('setLoading', false)
        commit('setError', true)

        return error
      })
  },
  contactUs ({commit}, payload) {
    commit('setLoading', true)

    return api.contact.contactUs(payload)
      .then(response => {
        commit('setLoading', false)
        commit('setSuccess', true)

        return response
      })
      .catch(error => {
        commit('setLoading', false)
        commit('setError', true)

        return error
      })
  },
  setSuccess ({commit}, success) {
    commit('setSuccess', success)
  },
  setError ({commit}, error) {
    commit('setError', error)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
